import { render } from "./NavbarPublicoComponent.vue?vue&type=template&id=2daea626&scoped=true"
import script from "./NavbarPublicoComponent.vue?vue&type=script&lang=js"
export * from "./NavbarPublicoComponent.vue?vue&type=script&lang=js"

import "./NavbarPublicoComponent.vue?vue&type=style&index=0&id=2daea626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2daea626"]])

export default __exports__